﻿/* globals __tcfapi */
const cookieService = require('../Global/cookie-service');
const habUtils = require('../Global/habitaclia-utils');

class SeenHandler{
    
    constructor(){
        this._COOKIENAME = 'InmueblesVisitados';
        this.__inmueblesVisitados = [];
        __tcfapi && __tcfapi('getTCData',2, data => {
            if (data.purpose.consents[5] && data.purpose.consents[6] && data.purpose.consents[10]){
                this.visitadosCookieManager();
            } 
        });
    }

    visitadosCookieManager() {
        let valor = "";
        valor = decodeURIComponent(cookieService.getCookie(this._COOKIENAME));
        if (valor !== "" && !!valor && valor !== 'null') {
            const splited = valor.split(",");
            const longitud = splited.length;
            for (var i = 0; i < longitud; i++) {
                this.__inmueblesVisitados.push(splited[i]);
            }
        }
    }

    addInmuebleVisitado(codigoAnuncio) {
        var self = this;
        __tcfapi && __tcfapi('getTCData',2, data => {
            if (data.purpose.consents[5] && data.purpose.consents[6] && data.purpose.consents[10]){
                if (!habUtils.ExistStringInArray(codigoAnuncio, self.__inmueblesVisitados)) {
                    self.__inmueblesVisitados.push(codigoAnuncio);
                    let valor = self.__inmueblesVisitados.join();
                    cookieService.setCookie(self._COOKIENAME, valor, 10000);
                } 
            }
        });
    }

    estaVisitado(codigoInmueble) {
        const longitud = this.__inmueblesVisitados.length;
        for (let i = 0; i < longitud; i++) {
            if (this.__inmueblesVisitados[i] === codigoInmueble)
                return true;
        }
        return false;
    }

    setInmueblesVisitados(inmueblesVisitadosString) {
        this.__inmueblesVisitados = [];

        cookieService.setCookie(this._COOKIENAME, inmueblesVisitadosString, 10000);

        if (inmueblesVisitadosString) {
            const splited = inmueblesVisitadosString.split(",");
            const longitud = splited.length;
            for (let i = 0; i < longitud; i++) {
                this.__inmueblesVisitados.push(splited[i]);
            }
        }
    }
}
export default SeenHandler;